import { ADD_ADMIN_SOW_ORDER_DETAIL, UPDATE_ADMIN_SOW_ORDER_DETAIL } from '../action';

// Initial State
const initialState = null;

const sowOrderDetailReducer = (state = initialState, action) => {
     switch (action.type) {
          case ADD_ADMIN_SOW_ORDER_DETAIL: {
               return action.payload;
          }
          case UPDATE_ADMIN_SOW_ORDER_DETAIL: {
               const newState = { ...state };

               if (Object.keys(action.payload).length) {
                    Object.assign(newState, { ...action.payload });
               }

               return newState;
          }

          default:
               return state;
     }
};

export default sowOrderDetailReducer;
